import styled from 'styled-components';

import { Button } from '@xing-com/button';
import { mediaConfined } from '@xing-com/layout-tokens';
import { TipBoxPreset } from '@xing-com/tip-box';

export const StyledButton = styled(Button)<{ $isWide: boolean }>`
  width: ${({ $isWide }) => ($isWide ? '100%' : 'auto')};
  white-space: nowrap;
  padding: 0;
`;

export const StyledTipBox = styled(TipBoxPreset)<{ $isWide: boolean }>`
  width: ${({ $isWide }) => ($isWide ? '200px' : '160px')};
`;

export const StyledTipBoxContainer = styled.div<{ $isWide: boolean }>`
  width: ${({ $isWide }) => ($isWide ? '100%' : 'auto')};

  @media ${mediaConfined} {
    flex-basis: ${({ $isWide }) => ($isWide ? '100%' : 'auto')};
  }

  > button {
    width: 100%;
  }
`;
